module.exports = __webpack_public_path__ + "static/media/Rome.faa8f4cc.jpg";